import { render, staticRenderFns } from "./OverdueInspections.vue?vue&type=template&id=2fa48378&"
import script from "./OverdueInspections.vue?vue&type=script&lang=js&"
export * from "./OverdueInspections.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports